export type NewsCategory = "news" | "gossip" | "review";

export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  content: string[];
  category: NewsCategory;
  source: string;
  publishedAt: string;
  cover: string;
  relatedMediaId?: string;
}

export const NEWS_CATEGORY_LABELS: Record<NewsCategory, string> = {
  news: "行业新闻",
  gossip: "片场花絮",
  review: "深度评论",
};

export const NEWS: NewsItem[] = [
  {
    id: "n01",
    title: "《迷雾追凶》口碑持续走高，悬疑剧迎来叙事新范式",
    summary: "上线三周，这部刑侦悬疑剧凭借扎实的剧本与克制的表演，成为近期讨论度最高的作品之一。",
    content: [
      "由何砚执导的悬疑剧集《迷雾追凶》自开播以来口碑持续走高，平台评分稳定在 8.8 分以上。该剧以十五年前的一桩旧案为引，用双线叙事逐步揭开真相。",
      "与追求强反转的同类作品不同，《迷雾追凶》把大量笔墨放在人物动机与细节铺垫上。制片方表示，团队在前期花了近一年时间打磨剧本，力求每一个线索都能自洽。",
      "业内人士认为，该剧的成功说明观众对「慢热型」悬疑作品依然有耐心，只要叙事足够扎实，长线口碑自然会带来讨论热度。",
    ],
    category: "review",
    source: "影视观察",
    publishedAt: "2026-10-08 09:30",
    cover: "https://readdy.ai/api/search-image?query=foggy%20city%20street%20at%20dawn%20with%20deep%20blue%20mist%20and%20orange%20street%20lamps%2C%20cinematic%20editorial%20photo%2C%20no%20text&width=1200&height=800&seq=17c-n01&orientation=landscape",
    relatedMediaId: "s01",
  },
  {
    id: "n02",
    title: "国庆档票房收官：现实题材与科幻同台竞逐",
    summary: "今年国庆档多部新片同台，现实题材与硬核科幻成为票房主力，观众结构进一步年轻化。",
    content: [
      "随着假期结束，今年国庆档票房正式收官。多部新片同台竞逐，其中现实题材与科幻作品表现尤为突出，合计贡献了档期过半票房。",
      "业内分析指出，观众的观影选择正在变得更加理性，单纯依赖阵容已难以保证成绩，剧本质量与口碑发酵成为关键变量。",
      "多家院线表示，未来将增加对中小成本优质作品的排片支持，让更多类型能够被观众看见。",
    ],
    category: "news",
    source: "票房日报",
    publishedAt: "2026-10-07 18:10",
    cover: "https://readdy.ai/api/search-image?query=cinema%20hall%20with%20warm%20orange%20seats%20and%20deep%20blue%20screen%20glow%2C%20cinematic%20editorial%20photo%2C%20no%20text&width=1200&height=800&seq=17c-n02&orientation=landscape",
  },
  {
    id: "n03",
    title: "《王朝的黎明》曝全新花絮：一场戏拍了整整七天",
    summary: "片方发布最新幕后花絮，揭秘剧中那场气势恢宏的朝堂戏是如何完成的。",
    content: [
      "《王朝的黎明》官方发布了一段全新幕后花絮。视频中，剧组为一场朝堂对峙戏搭建了实景大殿，上百名演员同框调度，单场戏整整拍摄了七天。",
      "导演张牧之在采访中表示，这场戏是全剧的情绪高点，团队希望用最真实的场景让演员进入状态，而不是依赖后期。",
      "花絮上线后迅速登上热搜，不少观众留言称「看得出是用心在做」。",
    ],
    category: "gossip",
    source: "片场直击",
    publishedAt: "2026-10-06 14:22",
    cover: "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20hall%20with%20torchlight%20and%20deep%20blue%20shadows%2C%20behind%20the%20scenes%20editorial%20photo%2C%20no%20text&width=1200&height=800&seq=17c-n03&orientation=landscape",
    relatedMediaId: "s03",
  },
  {
    id: "n04",
    title: "综艺市场回暖：慢综艺与竞技类节目双双升温",
    summary: "最新数据显示，生活方式类与竞技类综艺的观众黏性明显提升，长视频平台加大投入。",
    content: [
      "根据第三方机构发布的数据，今年第三季度综艺市场整体回暖，慢综艺与竞技类节目表现尤为亮眼，多档节目进入热度榜前列。",
      "分析认为，观众在快节奏内容之外，对能够提供情绪价值的陪伴型节目需求上升，这也是慢综艺持续走红的原因之一。",
      "多家平台表示，接下来将推出更多兼具专业性与观赏性的节目，避免同质化竞争。",
    ],
    category: "news",
    source: "综艺前沿",
    publishedAt: "2026-10-05 11:05",
    cover: "https://readdy.ai/api/search-image?query=colorful%20tv%20studio%20with%20deep%20blue%20and%20orange%20stage%20lights%2C%20cinematic%20editorial%20photo%2C%20no%20text&width=1200&height=800&seq=17c-n04&orientation=landscape",
  },
  {
    id: "n05",
    title: "《星际回声》导演谈创作：我们想拍的不是特效，是孤独",
    summary: "这部科幻作品以近乎克制的方式讲述深空航行，导演首次公开回应创作初衷。",
    content: [
      "《星际回声》上映后，关于「硬科幻是否需要情绪」的讨论持续不断。导演 A. 卡尔森在最新采访中回应，团队真正想拍的是人在无垠宇宙中的孤独感。",
      "影片中大量使用长镜头与自然音效，刻意减少配乐，让观众与角色一同感受深空的安静。",
      "有影评人评价，这种处理方式让科幻片重新回到了「人的故事」这一原点。",
    ],
    category: "review",
    source: "电影手册",
    publishedAt: "2026-10-04 20:40",
    cover: "https://readdy.ai/api/search-image?query=astronaut%20silhouette%20before%20a%20giant%20orange%20nebula%20in%20deep%20blue%20space%2C%20editorial%20photo%2C%20no%20text&width=1200&height=800&seq=17c-n05&orientation=landscape",
    relatedMediaId: "m02",
  },
  {
    id: "n06",
    title: "《急诊室24小时》主创走进真实医院体验生活",
    summary: "为还原急诊室的真实状态，主创团队在开拍前进行了为期一个月的实地跟岗。",
    content: [
      "医疗剧《急诊室24小时》播出后，因细节真实收获不少好评。剧组透露，开拍前全体主演曾在多家医院急诊科跟岗整整一个月。",
      "主演表示，真正的急诊比剧本更紧张，医生们在混乱中保持冷静的能力让她深受触动，也因此重新理解了角色的职业信念。",
      "该剧目前在平台评分稳定在 8.5 分，被认为是今年职业剧的代表作之一。",
    ],
    category: "gossip",
    source: "片场直击",
    publishedAt: "2026-10-03 16:15",
    cover: "https://readdy.ai/api/search-image?query=modern%20hospital%20emergency%20corridor%20at%20night%20with%20deep%20blue%20light%20and%20warm%20orange%20glow%2C%20editorial%20photo%2C%20no%20text&width=1200&height=800&seq=17c-n06&orientation=landscape",
    relatedMediaId: "s04",
  },
  {
    id: "n07",
    title: "短剧与长剧之争：内容形态之争还是注意力之争？",
    summary: "短剧的快速崛起给长剧市场带来压力，但两者的受众与消费场景并不完全重叠。",
    content: [
      "近两年短剧市场快速扩张，一度被认为将冲击传统长剧。但从数据看，长剧观众的追剧习惯依然稳定，尤其是在晚间时段。",
      "多位从业者认为，短剧满足的是碎片化时间的即时爽感，而长剧提供的是完整世界的沉浸体验，两者并非简单的替代关系。",
      "真正值得行业警惕的，不是形态之争，而是内容是否足够扎实——无论长短，观众最终都会用作品说话。",
    ],
    category: "review",
    source: "影视观察",
    publishedAt: "2026-10-02 10:10",
    cover: "https://readdy.ai/api/search-image?query=smartphone%20and%20tv%20screen%20side%20by%20side%20with%20deep%20blue%20and%20orange%20glow%2C%20editorial%20photo%2C%20no%20text&width=1200&height=800&seq=17c-n07&orientation=landscape",
  },
  {
    id: "n08",
    title: "《长安夜行》美术特辑：一座盛唐长安是如何被还原的",
    summary: "从规整的里坊到灯火通明的夜市，美术团队用三个月时间完成了这座城市的重建。",
    content: [
      "电影《长安夜行》发布美术特辑，揭秘片中那座繁华热闹的盛唐长安是如何搭建的。美术指导介绍，团队参考了大量史料与壁画，力求还原当时的建筑规制与市井气息。",
      "为了拍出夜戏的层次感，剧组使用了上万盏灯具，并严格控制色温，让暖色的灯笼与冷色的夜色形成对比。",
      "特辑公布后，不少观众感叹「每一帧都像一幅画」。",
    ],
    category: "gossip",
    source: "幕后纪实",
    publishedAt: "2026-10-01 19:25",
    cover: "https://readdy.ai/api/search-image?query=sweeping%20ancient%20chinese%20city%20rooftops%20at%20night%20with%20glowing%20lanterns%2C%20deep%20blue%20and%20warm%20orange%2C%20editorial%20photo%2C%20no%20text&width=1200&height=800&seq=17c-n08&orientation=landscape",
    relatedMediaId: "m01",
  },
  {
    id: "n09",
    title: "新一批青年导演崛起，现实题材成为创作热点",
    summary: "越来越多青年导演把镜头对准日常生活，以细腻的观察赢得市场与口碑的双重认可。",
    content: [
      "近年来，一批青年导演带着自己的处女作走进大众视野。他们大多关注普通人的生活，用平实的镜头讲述真切的情感。",
      "业内认为，这股创作潮流的背后是观众审美的变化——人们更愿意为真实、有共鸣的故事买单。",
      "多家影视公司表示，将加大对青年创作力量的扶持，为行业注入新鲜血液。",
    ],
    category: "news",
    source: "影视观察",
    publishedAt: "2026-09-30 08:50",
    cover: "https://readdy.ai/api/search-image?query=film%20set%20with%20camera%20and%20director%20silhouette%20at%20warm%20orange%20dusk%2C%20deep%20blue%20sky%2C%20editorial%20photo%2C%20no%20text&width=1200&height=800&seq=17c-n09&orientation=landscape",
  },
  {
    id: "n10",
    title: "《巷口食堂》为何让人上头？聊聊治愈系剧集的情绪价值",
    summary: "没有强情节、没有大冲突，这部剧却让很多人在深夜追得停不下来。",
    content: [
      "《巷口食堂》开播以来一直保持高口碑，它几乎没有所谓的强情节，只是安静地讲一个个普通人的故事。",
      "有观众说，看这部剧就像在深夜走进一家小店，点一碗热面，被轻声问一句「今天辛苦了」。这种被理解的感觉，正是它的情绪价值所在。",
      "在节奏越来越快的当下，愿意慢下来讲述温暖的创作者，或许比想象中更被需要。",
    ],
    category: "review",
    source: "影视观察",
    publishedAt: "2026-09-29 21:30",
    cover: "https://readdy.ai/api/search-image?query=quiet%20old%20alley%20with%20a%20glowing%20small%20eatery%20at%20night%2C%20warm%20orange%20light%20and%20deep%20blue%20shadows%2C%20editorial%20photo%2C%20no%20text&width=1200&height=800&seq=17c-n10&orientation=landscape",
    relatedMediaId: "s07",
  },
  {
    id: "n11",
    title: "《暗流博弈》收官：一部耐心之作的长期主义",
    summary: "该剧热度并非爆发式，却凭借稳定口碑在后半程实现逆袭。",
    content: [
      "谍战剧《暗流博弈》近日收官。与许多追求开局高能的剧集不同，它用了大量篇幅铺垫人物与时代背景。",
      "正是这种耐心，让后半程的每一次抉择都格外有分量。收官当晚，相关话题登上多个平台热榜。",
      "有评论指出，这部剧证明了「慢」并不意味着「闷」，关键还是叙事是否有诚意。",
    ],
    category: "review",
    source: "影视观察",
    publishedAt: "2026-09-28 15:40",
    cover: "https://readdy.ai/api/search-image?query=rainy%20night%20old%20city%20street%20with%20a%20single%20figure%20and%20orange%20lamp%2C%20deep%20blue%20mood%2C%20editorial%20photo%2C%20no%20text&width=1200&height=800&seq=17c-n11&orientation=landscape",
    relatedMediaId: "s08",
  },
  {
    id: "n12",
    title: "《山河故人记》重播再掀讨论，年代剧为何历久弥新",
    summary: "这部年代剧首播两年后重播，依旧打动了一大批新观众。",
    content: [
      "年代剧《山河故人记》近日在平台重播，再次引发讨论。许多第一次观看的年轻观众表示，剧中的家庭故事让他们想起自己的长辈。",
      "年代剧之所以历久弥新，或许是因为它讲述的是每个家庭都曾经历过的迁徙与坚守、告别与重逢。",
      "那些被时间沉淀下来的情感，总能跨越代际，直抵人心。",
    ],
    category: "news",
    source: "平台快讯",
    publishedAt: "2026-09-27 12:00",
    cover: "https://readdy.ai/api/search-image?query=vintage%20chinese%20riverside%20town%20at%20warm%20orange%20dusk%20with%20deep%20blue%20mountains%2C%20editorial%20photo%2C%20no%20text&width=1200&height=800&seq=17c-n12&orientation=landscape",
    relatedMediaId: "s05",
  },
];